import { IconButton, Stack, Typography } from '@mui/material';
import { LiveTranscriptWaveform } from 'src/components/Assistant/live-transcript/live-transcript-waveform';
import {
  liveTranscriptHeaderActionsSx,
  liveTranscriptHeaderCopyIconSx,
  liveTranscriptHeaderIconButtonSx,
  liveTranscriptHeaderStatusRowSx,
  liveTranscriptHeaderSx,
  liveTranscriptHeaderToggleIconSx,
} from 'src/components/Assistant/live-transcript/live-transcript.styles';
import { LiveTranscriptHeaderProps } from 'src/components/Assistant/live-transcript/live-transcript.types';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';

export const LiveTranscriptHeader = ({
  isCollapsed,
  isFinished,
  isStreaming,
  canCopy,
  canSearch,
  onExpandFromHeader,
  onToggleCollapse,
  onCopyTranscript,
  onOpenSearch,
}: LiveTranscriptHeaderProps) => (
  <Stack
    role="button"
    tabIndex={0}
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    onClick={() => {
      if (isCollapsed) {
        onExpandFromHeader();
      }
    }}
    sx={liveTranscriptHeaderSx(isCollapsed)}
  >
    <Stack direction="row" sx={liveTranscriptHeaderStatusRowSx}>
      <LiveTranscriptWaveform isFinished={isFinished} isStreaming={isStreaming} />
      <Typography variant="body2" fontWeight={600}>
        {isFinished ? 'Call ended' : 'Live Call'}
      </Typography>
    </Stack>

    <Stack direction="row" sx={liveTranscriptHeaderActionsSx}>
      <IconButton
        aria-label="Search transcript"
        size="small"
        disabled={!canSearch}
        onClick={(event) => {
          event.stopPropagation();
          onOpenSearch();
        }}
        sx={liveTranscriptHeaderIconButtonSx}
      >
        <DynamicIcon name="search" sx={liveTranscriptHeaderCopyIconSx} />
      </IconButton>
      <IconButton
        aria-label="Copy full transcript"
        size="small"
        disabled={!canCopy}
        onClick={(event) => {
          event.stopPropagation();
          onCopyTranscript();
        }}
        sx={liveTranscriptHeaderIconButtonSx}
      >
        <DynamicIcon name="content_copy" sx={liveTranscriptHeaderCopyIconSx} />
      </IconButton>
      <IconButton
        aria-label={isCollapsed ? 'Expand live transcript' : 'Collapse live transcript'}
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          onToggleCollapse();
        }}
        sx={liveTranscriptHeaderIconButtonSx}
      >
        <DynamicIcon
          name={isCollapsed ? 'expand_more' : 'expand_less'}
          sx={liveTranscriptHeaderToggleIconSx}
        />
      </IconButton>
    </Stack>
  </Stack>
);
